// extracted by mini-css-extract-plugin
export default {"operator":"WeF3xfSSKaHlQ7k","info":"zzJnMKZehQY_XJw","name":"Tbxn9pNAdgNuYOZ","service-name":"xMegiva3_4Xb2o2"};